// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneFilledSvg from "@fishx/icons-svg/es/asn/PhoneFilled";
import FishxIcon from '../components/FishxIcon';

var PhoneFilled = function PhoneFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneFilledSvg
  }));
};

PhoneFilled.displayName = 'PhoneFilled';
export default React.forwardRef(PhoneFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PhoneFilled.js
// module id = 3774
// module chunks = 0